var hasKeyboardNavigationCurrent = false;

function updateBodyClassKeyboardNavigation(hasKeyboardNavigation) {
  if (hasKeyboardNavigation == hasKeyboardNavigationCurrent) {
    return;
  }

  if (hasKeyboardNavigation) {
    document.body.classList.add('input-keyboard-navigation');
  }
  else {
    document.body.classList.remove('input-keyboard-navigation');
  }

  hasKeyboardNavigationCurrent = hasKeyboardNavigation;
}

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Tab') {
    return;
  }
  updateBodyClassKeyboardNavigation(true);
});

document.addEventListener('mousedown', () => {
  updateBodyClassKeyboardNavigation(false);
});

// const customEventNavigationTab = new CustomEvent('input_navigation_tab');
// const customEventNavigationMouse = new CustomEvent('input_navigation_mouse');

document.addEventListener("input_navigation_tab", function() {
  updateBodyClassKeyboardNavigation(true);
});

document.addEventListener("input_navigation_mouse", function() {
  updateBodyClassKeyboardNavigation(false);
});
